module.exports = __webpack_public_path__ + "static/image001-7eeb58f5bb15a19b32876a3404bf9aff.jpg";